'use client';
import { Dropdown as Dropdown$1 } from './Dropdown.js';
import { DropdownButton } from './DropdownButton.js';
import { DropdownHeading } from './DropdownHeading.js';
import { DropdownItem } from './DropdownItem.js';
import { DropdownList } from './DropdownList.js';
import { DropdownTrigger } from './DropdownTrigger.js';
import { DropdownTriggerContext } from './DropdownTriggerContext.js';

/**
 * Dropdown component, used to display a list of options.
 *
 * @example
 * <Dropdown.TriggerContext>
 *   <Dropdown.Trigger>Dropdown trigger</Dropdown.Trigger>
 *   <Dropdown placement='bottom-end'>
 *     <Dropdown.Heading>Dropdown</Dropdown.Heading>
 *     <Dropdown.List>
 *       <Dropdown.Item>
 *         <Dropdown.Button>Option</Dropdown.Button>
 *       </Dropdown.Item>
 *     </Dropdown.List>
 *   </Dropdown>
 * </Dropdown.TriggerContext>
 */
const Dropdown = Object.assign(Dropdown$1, {
    TriggerContext: DropdownTriggerContext,
    Heading: DropdownHeading,
    List: DropdownList,
    Item: DropdownItem,
    Button: DropdownButton,
    Trigger: DropdownTrigger,
});
Dropdown.TriggerContext.displayName = 'Dropdown.TriggerContext';
Dropdown.List.displayName = 'Dropdown.List';
Dropdown.Heading.displayName = 'Dropdown.Heading';
Dropdown.Item.displayName = 'Dropdown.Item';
Dropdown.Button.displayName = 'Dropdown.Button';
Dropdown.Trigger.displayName = 'Dropdown.Trigger';

export { Dropdown, DropdownButton, DropdownHeading, DropdownItem, DropdownList, DropdownTrigger, DropdownTriggerContext };
